
import React from 'react';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { Card, CardContent, CardHeader, Container, CssBaseline } from '@mui/material';
import axios from 'axios';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import PropTypes from 'prop-types';
import CustomSnackbar from '../../../../../Components/Snackbar/Snackbar';
import { genURL, genURLTEST } from '../../../../../_getjson';
import Optionreport from './Optionreport';



export default function EditOptionreport(props) {
    const { reportID } = props
    const [optionData, setOptiondata] = React.useState([])
    const [resoptionData, setResoptiondata] = React.useState([])
    const [delresoptionData, setDelresoptiondata] = React.useState([])
    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(1000)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")

    const [loadData, setLoadData] = React.useState(true)

    React.useEffect(() => {
        loadOptionold()
        return () => {
        };
    }, [reportID])

    const OptionData = async (val) => {
        console.log("optionData val", val)
        let array1
        try {
            if (val.length > 0) {
                //setLoadData(true)
                if (optionData.length > 0) {
                    // console.log("optionData optionData if case")

                    array1 = val.filter(val => {
                        return !optionData.find((val2) => {
                            //  console.log({valueID:val.id+":"+val2.id});
                            return val.nameen === val2.nameen
                        })
                    });

                    // console.log("optionData optionData if case", array1)

                    // await optionData.find((nnn, indexoption) => {
                    //     // console.log("optionData optionData optionData  nameen", nnn.nameen)
                    //     // return
                    //     val.find((x, indexval) => {
                    //         // console.log("optionData val  nameen ", x.nameen)
                    //         if (x.nameen !== nnn.nameen && x.nameen !== "" && x.nameth !== nnn.nameth && x.nameth !== "") {
                    //             console.log("optionData val  nameen ", x.nameen, "  optionData", nnn.nameen)
                    //             foundDuplicateName.push(x)
                    //         }
                    //     })
                    // })
                    // console.log("optionData foundDuplicateName", foundDuplicateName)

                } else {
                    console.log("optionData optionData else case")
                    array1 = val.filter(val => {
                        return val
                    })
                }
            } else {
                console.log("optionData val.length else case")
                //val.length else case
                array1 = []
            }


        } catch (error) {
            console.log("optionData error", error)
        }

        await setResoptiondata(array1)
        if (val.length > 0) {
            await setLoadData(false)
        }

    }
    const saveData = (val) => {
        // console.log("saveData resoptionData ", resoptionData)
        // console.log("saveData delresoptionData", JSON.stringify(delresoptionData))
        // console.log("saveData delresoptionData", genURLTEST('/optionreport?'))
        if (delresoptionData.length > 0) {
            let urloption = "/reportmanage/optionreportdel?"
            let data = new URLSearchParams();
            data.append("reportID", reportID)
            data.append("optionData", JSON.stringify(delresoptionData))
            axios.post(genURL(urloption), data).then(res => {
                console.log(res)
            })
        }
        if (resoptionData.length > 0) {
            let urloption = "/reportmanage/optionreport?"
            const parameteroptionData = new URLSearchParams();
            parameteroptionData.append("reportID", reportID);
            parameteroptionData.append("optionData", JSON.stringify(resoptionData));
            axios.post(genURL(urloption), parameteroptionData).then(res => {
                console.log("resdata option", res.data);
                if (res.data.status === "success") {
                    setMessagealert("บันทึกตัวเลือกรายงานสำเร็จ")
                    setColor("success")
                    setOpensnackbar(true)
                    setIcon(< CheckCircleOutlineRoundedIcon />)
                }
                setLoadData(true)
                //console.log("optionData", optionData);
            })
        }

        setTimeout(() => {
            props.CloseDialog(false)
        }, autoClose);


    }

    const loadOptionold = async () => {
        let url = `reportmanage/optiontreport/${reportID}?`
        console.log("reportsID", genURL(url));
        let elementreportoption = []
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log(" resdata reportoption", res.data)
            for (let index = 0; index < res.data.length; index++) {
                elementreportoption.push({ id: index, nameth: res.data[index].Reportoptionnameth, nameen: res.data[index].Reportoptionnameen, refReportoptiontype: res.data[index].refReportoptiontype + "-" + res.data[index].Reportoptiontypeanameth })
            }

        }).catch(error => {
            console.log(" resdata reportoption", error);

        });

        await console.log(" resdata reportoption", elementreportoption);
        await setOptiondata(elementreportoption)
    }
    const DelOptionData = async (val) => {
        await setLoadData(true)
        let arraydel
        if (val.length > 0) {
            if (optionData.length > 0) {
                // console.log("optionData optionData if case")

                arraydel = val.filter(val => {
                    return optionData.find((val2) => {
                        //  console.log({valueID:val.id+":"+val2.id});
                        return val.nameen === val2.nameen
                    })
                });
            } else {
                console.log("optionData optionData else case")
                // arraydel = val.filter(val => {
                //     return val
                // })
                arraydel = []
            }
        } else {
            arraydel = []
        }
        //  setRows((prevRows) => [...prevRows, createRow(defaultDataintable[index].nameen, defaultDataintable[index].nameth, defaultDataintable[index].refReportoptiontype)]);
        //  if (foundDuplicateName.length > 0) {
        await setDelresoptiondata(arraydel)
        //  }
        await setLoadData(false)
    }
    return <React.Fragment>
        <br />
        <CssBaseline />
        <Container>
            <Card sx={{ minWidth: 275 }}>
                <CardHeader
                    avatar={""}
                    action={
                        <IconButton aria-label="settings" onClick={e => saveData()} disabled={loadData}>
                            <SaveRoundedIcon sx={{ cursor: "pointer" }} />
                        </IconButton>
                    }
                    title=""
                    subheader=""
                />
                <CardContent>
                    <Optionreport Dataintable={e => OptionData(e)} defaultDataintable={optionData} Dataintableremove={e => DelOptionData(e)} />
                </CardContent>
            </Card>
        </Container>
        <CustomSnackbar place="br"
            color={color}
            icon={icon}
            autoClose={autoClose}
            message={messagealert}
            open={opensnackbar}
            closeNotification={() => { setOpensnackbar(false) }}
            close />


    </React.Fragment>
}

EditOptionreport.prototype = {
    reportID: PropTypes.string
}
